<template>
  <header class="home-header">
    <section class="navigation-top__container -header">
      <router-link to="/">
        <img src="/images/LogoMDA-EN.png" class="navigation-top__logo" alt=""/>
      </router-link>

      <ul class="navigation-top__list">
        <template v-for="entry in links">
          <a
            v-if="entry.external"
            :key="entry.label"
            :href="entry.link"
            target="_blank"
            rel="noopener noreferrer"
            class="navigation-top__item">
            {{ entry.label }}
          </a>

          <RouterLink
            v-else
            :key="entry.label"
            :to="{ hash: entry.hash }"
            class="navigation-top__item">
            {{ entry.label }}
          </RouterLink>
        </template>
      </ul>

      <div class="navigation-top__burger" @click="$emit('toggle-sidenav')">
        <svg-icon id="menu" />
      </div>
    </section>

    <section class="home-header__container">
      <HomeHeaderSlider/>
    </section>

    <span data-peekaboo />
  </header>
</template>

<script>
import HomeHeaderSlider from './HomeHeaderSlider.vue';

export default {
  name: 'HomeHeader',
  components: { HomeHeaderSlider },
  data() {
    return { viewportHeight: window.innerHeight }
  },
  computed: {
    links() {
      const menu = this.$i18n.t('menu')
      return menu.map(entry => {
        return entry.external 
          ? { external: true, label: entry.label, link: entry.link }
          : { external: false, label: this.$i18n.t(`menuLabels.${entry.hash}`), hash: `#${entry.hash}` }
      })
    }
  }
}
</script>
